export default "__VITE_ASSET__9H3qWCRy__"